export default {
    url: '/import',
    template: '<user-import sites="vm.sites"><user-import/>',
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManageUsers();
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/import/index.js